import './Components/css/swiper-bundle.min.css';
import React, { useEffect, useState, } from 'react';
import axios from 'axios';
import './login.css';
import { useNavigate ,NavLink} from 'react-router-dom';
import apiurl from './Api';
import qs from 'qs';
import styles from './Components/css/user.module.css';
axios.defaults.withCredentials = true;

function Forgot() {
  const [step, setStep] = useState(1); // 1=username, 2=otp, 3=new password
  const [username, setUsername] = useState('');
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [passwords, setPasswords] = useState({ newPass: '', confirmPass: '' });
  const [loading, setLoading] = useState(false);
const [message, setMessage] = useState({ text: null, color: "green" });

const [focus, setFocus] = useState({ username: false, password: false ,confirm:false});

  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Forgot Password | MERAQUI";
  }, []);

  // Toast-like message (green box right side)
const showMessage = (text, color = "green") => {
  setMessage({ text, color });
  setTimeout(() => setMessage({ text: null, color: "green" }), 3000);
};


  // Handle OTP input change
  const handleOtpChange = (value, index) => {
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Auto focus next
      if (value && index < 5) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (step === 1) {

        if(username==""){
          showMessage('Please fill the Username',"darkred");
          return false;
        }
        // Step 1: Send OTP
        const res = await axios.post(
          apiurl + 'otp.php',
          qs.stringify({ username, action: 'send' }),
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        );

        if (res.data.status) {
          showMessage(res.data.message || 'OTP sent successfully',"green");
          setStep(2);
        }
        else{
          showMessage(res.data.message,"darkred");
        }
      } else if (step === 2) {
        // Step 2: Verify OTP
        const enteredOtp = otp.join('');
        const res = await axios.post(
          apiurl + 'otp.php',
          qs.stringify({ username, otp: enteredOtp, action: 'verify' }),
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        );

        if (res.data.status) {
          showMessage('OTP verified successfully',"green");
          setStep(3);
        } else {
          showMessage(res.data.message || 'Invalid OTP',"darkred");
        }
      } else if (step === 3) {
        const enteredOtps = otp.join('');
        // Step 3: Reset Password
        if (passwords.newPass !== passwords.confirmPass) {
          showMessage('Passwords do not match',"darkred");
          setLoading(false);
          return;
        }

        const res = await axios.post(
          apiurl + 'otp.php',
          qs.stringify({
            username,
            password: passwords.newPass,
            otp:enteredOtps,
            action: 'reset'
          }),
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        );

        if (res.data.status) {
          showMessage(res.data.message || 'Password reset successfully',"green");
          setTimeout(() => navigate('/'), 1000);
        } else {
          showMessage(res.data.message || 'Error resetting password',"darkred");
        }
      }
    } catch (err) {
      console.error(err);
      showMessage('Something went wrong',"darkred");
    } finally {
      setLoading(false);
    }
  };
  const handlePaste = (e) => {
  const data = e.clipboardData.getData("text").trim();
  
  // Check if the pasted content is a number (optional but recommended)
  if (!/^\d+$/.test(data)) return; 

  const pasteData = data.split("").slice(0, otp.length); // Take only what fits
  
  const newOtp = [...otp];
  pasteData.forEach((char, index) => {
    newOtp[index] = char;
  });

  setOtp(newOtp); // Assuming your state setter is named setOtp

  // Focus the last filled input or the next empty one
  const lastIndex = Math.min(pasteData.length, otp.length - 1);
  document.getElementById(`otp-${lastIndex}`).focus();
};

const handleKeyDown = (e, index) => {
  if (e.key === 'Backspace') {
    // If current box is empty and not the first box, move focus back
    if (!otp[index] && index > 0) {
      const newOtp = [...otp];
      newOtp[index - 1] = ""; // Clear the previous box
      setOtp(newOtp);
      document.getElementById(`otp-${index - 1}`).focus();
    }
  }
};

  return (
    <>
    {message.text && (
  <div
    style={{
      position: 'fixed',
      top: '20px',
      right: '20px',
      background: message.color,   // dynamic color
      color: 'white',
      padding: '10px 20px',
      borderRadius: '8px',
      boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
      zIndex: 1000,
      transition: 'all 0.5s ease'
    }}
  >
    {message.text}
  </div>
)}


      <div className="l-form">
        <div className="shape1"></div>
        <div className="shape2"></div>

        <div className="form">
          <img
            src={process.env.PUBLIC_URL + "/admin_assets/images/media/authentication.svg"}
            alt=""
            className="form__img"
          />

          <form onSubmit={handleSubmit} className="form__content">
             <div className="mb-3" style={{textAlign:'center'}}>
                    <a href="#">
                        <img src={"/images/meraqui-logo.png"} className="authentication-brand desktop-logo"  style={{filter:'invert(1)npm start',height:'2rem',margin:'auto'}}/>
                    </a>
                </div>
            <p className="h5 fw-semibold mb-2 text-center">Forgot Your Password</p>
            <p className={`mb-3 text-muted fw-normal ${styles['text-center']}`}>
              End-To-End Encryption
            </p>

            {/* Step 1: Username */}
            {step === 1 && (
              <div className={`form__div ${focus.username ? "focus" : ""}`} style={{marginTop:'35px'}}>
                <div className="form__icon">
                  <i className="bx bx-user-circle"></i>
                </div>
                <div className="form__div-input">
                  <label className="form__label">Username</label>
                  <input
                    type="text"
                    className="form__input"
                    onFocus={() => setFocus({...focus, username: true})} 
                    onBlur={(e) => setFocus({...focus, username: e.target.value !== ""})}
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder=" "
                  />
                </div>
              </div>
            )}

            {/* Step 2: OTP */}
            {step === 2 && (
              <div className="otp-box" style={{ display: 'flex', gap: '8px', marginTop: '20px',justifyContent:'center',marginBottom:'20px' }}>
                {otp.map((digit, i) => (
                  <input
                    key={i}
                    id={`otp-${i}`}
                    type="text"
                    maxLength="1"
                    placeholder='X'
                    value={digit}
                    onPaste={(e) => handlePaste(e)}
                    onKeyDown={(e) => handleKeyDown(e, i)}
                    onChange={(e) => handleOtpChange(e.target.value, i)}
                    style={{
                      width: '40px',
                      height: '40px',
                      textAlign: 'center',
                      fontSize: '18px',
                      border: '1px solid #ccc',
                      borderRadius: '6px'
                    }}
                  />
                ))}
              </div>
            )}

            {/* Step 3: New Password */}
            {step === 3 && (
              <>
                
                <div className={`form__div ${focus.password ? "focus" : ""}`}>
                <div className="form__icon">
                  <i className="bx bx-user-circle"></i>
                </div>
                <div className="form__div-input">
                  <label className="form__label">New Password</label>
                   <input
                    type="text"
                    className="form__input"
                    value={passwords.newPass}
                    onFocus={() => setFocus({...focus, password: true})} 
                    onBlur={(e) => setFocus({...focus, password: e.target.value !== ""})}
                    onChange={(e) =>
                      setPasswords({ ...passwords, newPass: e.target.value })
                    }
                  />
                </div>
              </div>
               <div className={`form__div ${focus.confirm ? "focus" : ""}`}>
                <div className="form__icon">
                  <i className="bx bx-user-circle"></i>
                </div>
                <div className="form__div-input">
                  <label className="form__label">Confirm Password</label>
                   <input
                    type="password"
                    className="form__input"
                    
                    onFocus={() => setFocus({...focus, confirm: true})} 
                    onBlur={(e) => setFocus({...focus, confirm: e.target.value !== ""})}
                    value={passwords.confirmPass}
                    onChange={(e) =>
                      setPasswords({ ...passwords, confirmPass: e.target.value })
                    }
                  />
                </div>
              </div>
              
              </>
            )}
            <NavLink className="text-primary" to="/" data-discover="true" style={{float: 'right',marginBottom: '20px', fontWeight: '600'}}>Back to Login.</NavLink>

            <button type="submit" className="form__button" disabled={loading}>
              {loading ? (
                <span className="spinners"></span>
              ) : step === 1 ? (
                "Send OTP"
              ) : step === 2 ? (
                "Verify OTP"
              ) : (
                "Reset Password"
              )}
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default Forgot;
